import { handleHideModal } from 'components/global/_helpers/global.helpers';
import SimpleModal from 'components/global/SimpleModal';
import { handleSubmitRemoveInvestor } from 'components/views/FounderDeal/_helpers/founderDeal.events';
import { $form, $view } from 'signals/global.signals';

const FounderDealRemoveInvestorModal = () => (
  <SimpleModal
    show={$view.value.activeModal === 'founder-deal-remove-investor'}
    onHide={handleHideModal}
    centered
    title="Remove Investor"
    onPrimaryClick={handleSubmitRemoveInvestor}
    primaryButtonText="Remove"
    secondaryButtonText="Cancel"
    onSecondaryClick={handleHideModal}
    isLoading={$view.value.isModalLoading}
  >
    <p>Are you sure you want to remove <b className="text-warning">{$form.value.investorName}</b> from <b className="text-info">{$form.value?.dealName}</b>? <br /><small className="text-gray-300">Note: This will NOT remove them from your account.</small></p>
  </SimpleModal>
);

export default FounderDealRemoveInvestorModal;
